















































































import { Component, Vue, Lifecycle, Mixin } from 'av-ts'
import { EventBus } from '@/eventbus'
import { VueUtils } from '@/mixins'
import { ITestResult, IUser } from '@/models'
import { StoreType } from '@/store'
import * as Utils from '@/utils'

@Component({
  store: ['user'],
})
export default class Home extends Mixin(EventBus, VueUtils) {
  $store!: StoreType
  loading = false

  testResults = null as ITestResult[] | null

  test(msg?: string) {
    console.debug(`*** TEST ${msg?msg:''} ***`)
    return false
  }

  lessonWordCount(lessonId: string): number | undefined {
    if (this.$store.lessons) {
      const lesson = this.$store.lessons.find(_ => _._id == lessonId)
      if (lesson) {
        return lesson.words.length
      }
    }
  }

  @Lifecycle
  async created() {
    console.debug('[Home.vue] created')
    this.testResults = await this.$store.getTestResults(true)
  }
  
  async deleteResult(testResult: ITestResult) {
    console.debug('[Home.vue] deleteResult', testResult)
    if (! testResult._id) throw new Error('Cannot delete TestResult without an ID')
    const idx = this.testResults!.findIndex(_ => _._id == testResult._id)
    if (idx != -1) {
      await this.$store.deleteResult(testResult._id)
      this.testResults!.splice(idx, 1)
    }
  }

  replayTest(testResult: ITestResult) {
    console.debug('[Home.vue] replayTest', testResult)
    this.$router.push({ name: 'lessonTest', params: { id: testResult.lesson._id, testResultId: testResult._id! } })
  }

  viewTest(testResult: ITestResult) {
    this.$router.push({ name: 'testResult', params: { testResultId: testResult._id! } })
  }
}
